export enum GroupedDataType {
  status = 'status',
  category = 'category',
  date = 'date',
  company = 'company',
}
